import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, sessionToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Persist the bearer token for browsers that block 3rd-party cookies.
        if (data?.session_token) sessionToken.set(data.session_token);
        setUser(data);
        // remove hash and go to dashboard
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        const msg = e.response?.data?.detail || "Sign-in failed";
        navigate("/login", { replace: true, state: { error: msg } });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-serif-villa text-2xl text-[#2B2B2B]">Un momento…</div>
        <div className="text-sm text-[#7A7A7A] mt-2 tracking-wider uppercase">Preparing your casa</div>
      </div>
    </div>
  );
}
